import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { forkJoin, Subject, Subscription } from 'rxjs';
import {
  Building,
  IBuilding,
} from 'src/app/building-managment/building-management-interfaces';
import {
  BuildingFLoorUnit,
  Floor,
  IBuildingFloorUnit,
  IFloor,
} from 'src/app/floor-management/floor-management-interface';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import {
  IAccessDetail,
  IUnitAndAccessPoint,
  IUnitDetail,
} from '../../user-management-interfaces';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-access-point-buildings',
  templateUrl: './access-point-buildings.component.html',
  styleUrls: ['./access-point-buildings.component.scss'],
})
export class AccessPointBuildingsComponent
  implements OnInit, AfterViewChecked, OnDestroy
{
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @ViewChild('buildingListing') buildingListing!: ElementRef;

  @Input() selectedUnitAccessPoint = {} as IUnitAndAccessPoint;
  @Output() selectedUnitAccessPointChange =
    new EventEmitter<IUnitAndAccessPoint>();
  @Input() buildingList!: Building[];
  @Output() submitToParent = new EventEmitter();

  formGroup!: FormGroup;
  submited = false;
  public toggleFormUnit = false;
  public toggleSubHeading = false;
  validateUnitAccessPoint = false;
  selectedBuilding: IBuilding | undefined;
  selectedSiteId?: String | null;
  floorUnits: any | undefined;
  floorUnitsCopy: any | undefined;
  selectedBuildingFloors: any[] = [];
  subscription: Subscription | undefined;
  sharedData?: ISharedData;
  markAll: string | undefined;
  searchUnit: string | undefined;

  readonly LANG_CONST = LANG_CONST;
  hasAccessPoints: boolean = false;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private stateManagementService: StateManagementService,
    private floorManagementService: FloorManagementService,
    private sharedDataService: SharedDataService,
    private notificationService: NotificationService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description control getter formgroup
   * @returns rective controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  /**
   * @description angular hook run after constructor
   * get userDetails formInstance for user first name and last name
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    if (!this.buildingList) {
      this.notificationService.showError(
        this.translate.instant('RECORD_NOT_FOUND')
      );
    }
    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
    });

    this.selectedSiteId =
      this.stateManagementService.getSharedData()?.selectedSite?.siteId;
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    if (this.toggleFormUnit) this.toggleFormUnit = false;
    else this.stepperChange.emit((this.stepper += -1));
  }

  /**
   *
   * @param selectedBuilding building Id object
   * @description add building with unit
   * @returns void
   */
  addBuildingUnit(selectedBuilding: IBuilding): void {
    this.searchUnit = '';
    this.floorUnits = []; //empty before load new data
    this.floorUnitsCopy = []; //empty copy before loading new data
    this.selectedBuildingFloors = []; //empty before load new data
    this.selectedBuilding = selectedBuilding;
    this.getFloorByBuildingId(selectedBuilding?.buildingId);
  }

  /**
   * @param buildingId selected building id
   * @description get floors and units given buildingid
   * @returns void
   */
  getFloorByBuildingId(buildingId: string): void {
    let finalise = new Subject();
    this.subscription = this.floorManagementService
      .getAllFloorsByBuildingId(this.selectedSiteId, buildingId)
      .pipe(
        takeUntil(finalise),
        mergeMap((floors: Floor) => {
          floors?.map((floor: IFloor) =>
            this.selectedBuildingFloors.push({
              floorName: floor?.floorName,
              floorId: floor?.floorId,
              wingName: floor?.wingName,
            })
          ); // hold ids to merge into unit

          let floorObservables = floors?.map((floor: IFloor) =>
            this.floorManagementService.getUnitsAndAccessPointsByFloor(
              this.selectedSiteId,
              buildingId,
              floor?.floorId
            )
          );
          return forkJoin(floorObservables);
        })
      )
      .subscribe({
        next: (units: any) => {
          this.toggleFormUnit = !this.toggleFormUnit;

          units?.map((unit: any, i: number) => {
            if (unit.length) {
              unit.floorName = this.selectedBuildingFloors[i].floorName;
              unit.wingName = this.selectedBuildingFloors[i].wingName;
              return unit.map((unitRecord: any) => {
                unitRecord.floorId = this.selectedBuildingFloors[i].floorId;
                unit.map((unit: any) => {
                  unit.buildingId = buildingId;
                  unit.status = false;
                  unit.siteId = this.sharedData?.selectedSite?.siteId;
                });
              });
            }
          });

          // remove when get a nested empty array
          this.floorUnits = units?.filter((item: any) => {
            return item.length;
          });
          //updating floor units copy
          this.floorUnitsCopy = Object.assign([], this.floorUnits);

          this.hasAccessPoints = this.floorUnits?.some((item: any) =>
            item.some((unit: any) => unit.accessPointName)
          );
          // pre selected floor unit if entity not empty
          this.preSelectedFloorUnit();
          this.checkAllMarkUnits();
          /**
           * self unsubscribing observable by using takeUntil
           */
          finalise.next();
          finalise.complete();
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('getFloorByBuildingId', err);
          this.notificationService.showError(
            this.translate.instant('NO_FLOORS_AVAILABLE_IN_BULIDING')
          );
        },
      });
  }

  /**
   * @description load time check if any units selected checked mark
   * @return void
   */
  preSelectedFloorUnit(): void {
    const entityControl: BuildingFLoorUnit = this.formInstance.entities
      ?.value as BuildingFLoorUnit;
    if (entityControl) {
      entityControl.forEach((selectedVal: IBuildingFloorUnit) => {
        this.floorUnits?.flat().map((floorUnit: any) => {
          if (floorUnit?.unitId && floorUnit.unitId === selectedVal.unitId) {
            return (floorUnit.status = true);
          } else if (
            floorUnit?.accessPointId &&
            floorUnit.accessPointId === selectedVal.accessPointId
          ) {
            return (floorUnit.status = true);
          }
        });
        this.floorUnitsCopy = Object.assign([], this.floorUnits);
      });
    }
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  submit(): void {
    this.submited = true;
    if (this.formGroup.invalid) return;
    this.submitToParent.emit(); //submit parent form
  }
  ngAfterViewChecked(): void {
    if (this.buildingListing && this.buildingListing.nativeElement) {
      this.buildingListing.nativeElement.focus();
    }
  }

  /**
   * @description reset toggle form based on selected building
   * @returns void
   */
  resetToggleFormState(): void {
    this.toggleFormUnit = false;
    this.searchUnit = '';
  }

  /**
   * @param unit current unit id
   * @description update unit status
   * returns void
   */
  updateUnitStatus(unit: any): void {
    unit.status = !unit.status;
    this.checkAllMarkUnits();
    this.validateUnitAccessPointSubmit();
  }

  /**
   * @description toggle check if all selected set value true else false
   * @returns void
   */
  checkAllMarkUnits(): void {
    if (
      this.floorUnits?.flat()?.length == this.floorUnitsCopy?.flat()?.length
    ) {
      this.markAll = this.floorUnits
        ?.flat()
        ?.filter((floor: any) => floor?.accessPointName)
        ?.every((floor: any) => floor.status === true);
    } else {
      this.markAll = this.floorUnitsCopy
        ?.flat()
        ?.filter((floor: any) => floor?.accessPointName)
        ?.every((floor: any) => floor.status === true);
    }
  }

  /**
   * @description any of unit or even access point select submit button unable
   * @returns void
   */
  validateUnitAccessPointSubmit(): void {
    this.validateUnitAccessPoint = this.floorUnits
      ?.flat()
      .some((floor: any) => floor.status === true);
  }

  /**
   * @description add new units
   * @returns void
   */
  addUnit(): void {
    this.toggleFormUnit = !this.toggleFormUnit;
    const flatFloorUnit = this.floorUnitsCopy?.flat();
    const counter = flatFloorUnit?.filter(
      (unit: any) =>
        unit.status == true &&
        unit.buildingId == this.selectedBuilding?.buildingId
    )?.length;

    this.buildingList?.map((building: any) => {
      if (building.buildingId == this.selectedBuilding?.buildingId) {
        building.buildingCount = counter;
      }
    });
    this.setEntitiesControlVal(flatFloorUnit);

    this.selectedUnitsAndAccessPoints(flatFloorUnit);
    this.toggleSubHeadingHandler();
  }

  private selectedUnitsAndAccessPoints(flatFloorUnit: any) {
    const siteName = this.sharedData?.selectedSite?.siteName;
    if (
      !(
        this.selectedUnitAccessPoint?.units?.length ||
        this.selectedUnitAccessPoint?.accessPoints?.length
      )
    ) {
      this.addNewSelectedUnitAndAccesspoint(flatFloorUnit, siteName);
    } else {
      const holdSelectedUnits = this.selectedUnitAccessPoint?.units?.filter(
        (unit) => unit.buildingId != this.selectedBuilding!.buildingId
      );
      this.selectedUnitAccessPoint.units = holdSelectedUnits;

      const holdSelectedAccessPoints =
        this.selectedUnitAccessPoint.accessPoints.filter(
          (accesspoint) =>
            accesspoint.buildingId != this.selectedBuilding!.buildingId
        );
      this.selectedUnitAccessPoint.accessPoints = holdSelectedAccessPoints;

      this.addNewSelectedUnitAndAccesspoint(flatFloorUnit, siteName);
    }

    this.selectedUnitAccessPointChange.emit(this.selectedUnitAccessPoint);
  }

  private addNewSelectedUnitAndAccesspoint(
    flatFloorUnit: any,
    siteName: String | null | undefined
  ) {
    flatFloorUnit.forEach((floor: any) => {
      if (floor.unitId && floor.status) {
        const unit: IUnitDetail = {
          unitName: floor?.unitName,
          floorName: floor?.floorName,
          buildingName: this.selectedBuilding!.buildingName,
          buildingId: this.selectedBuilding!.buildingId,
          siteName: siteName!,
        };
        this.selectedUnitAccessPoint?.units?.push(unit);
      } else if (floor.accessPointId && floor.status) {
        const accessPoint: IAccessDetail = {
          accessPointName: floor?.accessPointName,
          floorName: floor?.floorName,
          buildingName: this.selectedBuilding!.buildingName,
          buildingId: this.selectedBuilding!.buildingId,
          siteName: siteName!,
        };
        this.selectedUnitAccessPoint?.accessPoints?.push(accessPoint);
      }
    });
  }

  /**
   * @param flatFloorUnit floors of units with flat array
   * @description check value exists on control
   * if exists call removeRecordBuildingId function
   * else set new value
   * @returns void
   */
  setEntitiesControlVal(flatFloorUnit: any): void {
    const entitiesControl: any = this.formInstance?.entities?.value;
    if (!entitiesControl || entitiesControl?.length === 0) {
      this.formInstance?.entities?.setValue(
        flatFloorUnit.filter((unit: any) => unit.status)
      );
    } else if (entitiesControl.length) {
      this.removeRecordBuildingId(this.selectedBuilding?.buildingId);
      this.addNewEntityByBuildingId();
    }
  }

  /**
   * @param buildingId current building id
   * @description remove all record from selected building id
   * @returns void
   */
  removeRecordBuildingId(buildingId: string | undefined): void {
    let entitiesControl: any = this.formInstance.entities.value;
    entitiesControl = entitiesControl?.filter(
      (accesspoint: any) => accesspoint.buildingId != buildingId
    );
    this.formInstance.entities.setValue(
      entitiesControl?.length < 1 ? '' : entitiesControl
    );
  }

  /**
   * @description hold old and append with new value if find similar changes
   * @returns void
   */
  addNewEntityByBuildingId(): void {
    const entitiesControl: any = this.formInstance.entities.value;
    const upatedEntities = [
      ...this.floorUnits
        ?.flat()
        .filter((accesspoint: any) => accesspoint.status),
      ...entitiesControl,
    ];
    this.formInstance.entities.setValue(upatedEntities);
  }

  /**
   * @param param {buildingId} selected building
   * @description get the count of selected units add back to building object
   * @returns void
   */
  getCount({ buildingId }: { buildingId: string }): number {
    return this.floorUnits
      ?.flat()
      ?.filter(
        (accesspoint: any) =>
          accesspoint.status && accesspoint.building == buildingId
      )?.length;
  }

  /**
   * @description select unselect all list item
   * @returns void
   */
  markList() {
    this.floorUnits?.map((floorUnit: any) => {
      floorUnit?.map((unit: any) => {
        if (unit?.accessPointId) unit.status = this.markAll;
        else unit.status = false;
      });
    });
    this.floorUnitsCopy?.map((floorUnit: any) => {
      floorUnit?.map((unit: any) => {
        if (unit?.accessPointId) unit.status = this.markAll;
        else unit.status = false;
      });
    });
    this.validateUnitAccessPointSubmit();
  }

  toggleSubHeadingHandler(): void {
    this.toggleSubHeading = this.buildingList.some(
      (building: any) => building.buildingCount > 0
    );
  }

  /**
   * @param event selected value
   * @description search any keyword
   * this method will be implemented when search unit funcition
   * will be added to this.
   * @returns void
   */
  searchUnits(data: string): void {
    this.searchUnit = data;
    this.checkAllMarkUnits();
  }

  /**
   * @description angular hook call when angular unmount component
   * @returns void
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
